import { render, staticRenderFns } from "./CargueGestion.vue?vue&type=template&id=24fb971d&"
import script from "./CargueGestion.vue?vue&type=script&lang=js&"
export * from "./CargueGestion.vue?vue&type=script&lang=js&"
import style0 from "./CargueGestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports